module.exports = __webpack_public_path__ + "img/Monte_Kope_71.9208cfd2.jpg";